var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCompleted(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 139,
    height: 139,
    viewBox: "0 0 139 139",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M62.5837 6.34366C66.5706 2.95123 72.4294 2.95123 76.4163 6.34366C79.418 8.89788 83.5284 9.71548 87.2791 8.50442C92.2607 6.89592 97.6735 9.13799 100.059 13.7979C101.854 17.3064 105.339 19.6347 109.268 19.9512C114.486 20.3715 118.628 24.5143 119.049 29.7323C119.365 33.6609 121.694 37.1455 125.202 38.9413C129.862 41.3265 132.104 46.7393 130.496 51.7209C129.285 55.4716 130.102 59.582 132.656 62.5837C136.049 66.5706 136.049 72.4294 132.656 76.4163C130.102 79.418 129.285 83.5284 130.496 87.2791C132.104 92.2607 129.862 97.6735 125.202 100.059C121.694 101.854 119.365 105.339 119.049 109.268C118.628 114.486 114.486 118.628 109.268 119.049C105.339 119.365 101.854 121.694 100.059 125.202C97.6735 129.862 92.2607 132.104 87.2791 130.496C83.5284 129.285 79.418 130.102 76.4163 132.656C72.4294 136.049 66.5706 136.049 62.5837 132.656C59.582 130.102 55.4716 129.285 51.7209 130.496C46.7393 132.104 41.3265 129.862 38.9413 125.202C37.1455 121.694 33.6609 119.365 29.7323 119.049C24.5143 118.628 20.3715 114.486 19.9512 109.268C19.6347 105.339 17.3064 101.854 13.7979 100.059C9.13799 97.6735 6.89592 92.2607 8.50442 87.2791C9.71548 83.5284 8.89788 79.418 6.34366 76.4163C2.95123 72.4294 2.95123 66.5706 6.34366 62.5837C8.89788 59.582 9.71548 55.4716 8.50442 51.7209C6.89592 46.7393 9.13799 41.3265 13.7979 38.9413C17.3064 37.1455 19.6347 33.6609 19.9512 29.7323C20.3715 24.5143 24.5143 20.3715 29.7323 19.9512C33.6609 19.6347 37.1455 17.3064 38.9413 13.7979C41.3265 9.13799 46.7393 6.89592 51.7209 8.50442C55.4716 9.71548 59.582 8.89788 62.5837 6.34366Z",
    fill: "#7284FF",
    stroke: "#314DDF",
    strokeWidth: 0.698492
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_2916_8691)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 69.5047,
    cy: 69.5658,
    r: 49.9422,
    fill: "#E7EAFF"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 69.5047,
    cy: 69.5658,
    r: 49.593,
    stroke: "#314DDF",
    strokeWidth: 0.698492
  })), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M69.5 105C89.1061 105 105 89.33 105 70C105 50.67 89.1061 35 69.5 35C49.8939 35 34 50.67 34 70C34 89.33 49.8939 105 69.5 105Z",
    fill: "#314DDF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54 71.4774L64.4803 81.9548L85.4322 61",
    stroke: "#314DDF",
    strokeWidth: 4.19095,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_2916_8691",
    x: 16.7685,
    y: 19.6235,
    width: 105.471,
    height: 105.472,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.79397
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.39698
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2916_8691"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2916_8691",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompleted);
export default __webpack_public_path__ + "static/media/completed.8509bbaeb6172a541337b8477ec1a817.svg";
export { ForwardRef as ReactComponent };